<template>
    <main-scaffold>
        <div slot="header">
            <el-menu :router="true" class="menu-bar" default-active="/eazable/services" mode="horizontal"
                      background-color="#0a609b" text-color="#fff" active-text-color="#fef9c7">

                <el-submenu index="/eazable/services" v-if="userSubRole ===3 || userSubRole===2">
                    <template slot="title">Home Services</template>
                    <el-menu-item index="/eazable/services/orders">Orders</el-menu-item>
                    <el-menu-item index="/eazable/mainService">Main Services</el-menu-item>
                    <el-menu-item index="/eazable/services/config">Sub Services</el-menu-item>
                    <el-menu-item index="/eazable/adv">Advertisement</el-menu-item>
                    <el-menu-item index="/eazable/services/vendors">Vendors</el-menu-item>
                </el-submenu>

                <el-submenu index="/eazable/helper" v-if="userSubRole ===3">
                    <template slot="title">Helper</template>
                    <el-menu-item index="/eazable/helper/orders">Orders</el-menu-item>
                    <el-menu-item index="/eazable/helper/config">Helper</el-menu-item>
                </el-submenu>

                <el-menu-item index="/eazable/property" v-if="userSubRole ===3 || userSubRole===2 || userSubRole ===4">Property
                </el-menu-item>

                <el-menu-item index="/eazable/company" v-if="userSubRole ===3 || userSubRole===2">Company
                </el-menu-item>

                <el-menu-item index="/eazable/users" v-if="userSubRole ===3 || userSubRole===2">Users
                </el-menu-item>

                <el-menu-item index="/eazable/e-wallet" v-if="userSubRole ===3 || userSubRole===1">E-wallet
                </el-menu-item>

                <el-menu-item index="/eazable/setting" v-if="userSubRole ===3">Setting
                </el-menu-item>

                <el-menu-item index="/eazable/settle" v-if="userSubRole ===3 || userSubRole===1">Settlement
                </el-menu-item>

                <el-menu-item index="/eazable/invoice" v-if="userSubRole ===3 || userSubRole===1">Statement
                </el-menu-item>

                <el-menu-item index="/eazable/receipt" v-if="userSubRole ===3 || userSubRole===1">Receipt
                </el-menu-item>

                <el-menu-item index="/eazable/register" v-if="userSubRole ===3 || userSubRole===4">E-form
                </el-menu-item>

                <el-submenu index="#" style="float: right">
                    <template slot="title"><h2 style="display: inline-block">{{userName}}</h2></template>
                    <el-menu-item @click="logOut" index="#">Logout</el-menu-item>
                </el-submenu>
            </el-menu>
        </div>
    </main-scaffold>
</template>
<script>
    import MainScaffold from "@/components/MainScaffold";
    import {allProperty} from "@/api/AuthApi";
    import {mapGetters} from "vuex";

    // noinspection JSUnusedGlobalSymbols
    export default {
        name: 'EazableMain',
        components: {MainScaffold},
        data() {
            return {
                data: [],
                propertyId: {},
                userInfo: '',
                propertyName: '',
                dialogVisible: false
            }
        },
        methods: {
            logOut() {
                this.$router.push('/');
                this.$store.commit('setUserInfo', null);
            },
            choosePropertyName() {
                this.dialogVisible = true;
                this.propertyId = this.userInfo.propertyId;
                allProperty(this.userInfo.userId).then(
                    res => {
                        this.data = res.data
                    }
                )
            }
        }, computed: mapGetters({
            userName: 'getUserName',
            userSubRole: 'getSubRole'
        })
    }
</script>

<style scoped>
    .el-menu{
        padding: 0 10px 0 10px;
        font-weight: bold;
    }

    .el-menu-item{
        font-family: 'Helvetica', 'Arial', sans-serif;
        font-weight: bold;
        text-align: center;
    }
</style>
